import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Sizes from '../Assets/Sizes';
import { FormattedMessage } from "react-intl";
import CheckIcon from '../Assets/check.png';

const Progress = styled.div`
  transition: all 500ms;
  position: relative;
  max-height: ${ props => props.visible ? Sizes.progressTrackerHeight : 0 }px;
  overflow: ${ props => props.visible ? 'visible' : 'hidden' };
  opacity: ${ props => props.visible ? 1 : 0 }
  display: flex;
  justify-content: center;
  width: 100%;
`;

const PhaseWrapper = styled.div`
  position: relative;
  width: ${ props => props.width }px;
  display: flex;
  flex-direction: column;
  align-items: center;

`;

const PhaseIndex = styled.div`
  background-color: ${ props => props.success ? props.theme.colors.surfaceTop : 'transparent' };
  border: ${ props => props.success ? 'none' : `${ props.current ? '3px' : '2px' } solid ${ props.theme.colors.surfaceTop }` };
  height: ${ Sizes.progressTrackerCircleSize }px;
  width: ${ Sizes.progressTrackerCircleSize }px;
  border-radius: 50%;
  color: ${ p => p.theme.colors.customNavigationBarColor || p.theme.colors.primaryTextInverted };
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${ props => props.current ? 'bold' : 'normal' };
  font-size: 0.9em;

  img {
    height: ${ Sizes.progressTrackerCircleSize }px;
    width: auto;
  }
`;

const PhaseText = styled.div`
  font-size: ${ Sizes.progressTrackerLabelSize }px;
  color: ${ props => props.theme.colors.customNavigationBarColor || props.primaryTextInverted };
  margin-top: ${ Sizes.smallMargin };
  font-weight: ${ props => props.current ? 'bold' : 'normal' };
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
  padding-left: ${ Sizes.textMargin };
  padding-right: ${ Sizes.textMargin };
`;


const PhaseConnector = styled.div`
  position: absolute;
  width: ${ props => props.width }px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  > div {
    height: 2px;
    width: ${ props => props.lineWidth }px;
    background-color: ${ p => p.theme.colors.surfaceTop };
  }
`;

const TopPart = styled.div`
  position: relative;
`;

export default class ProgressTracker extends PureComponent {
	componentDidMount() {
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	onResize = () => {
		this.forceUpdate()
	};


	render() {
		const { props } = this;
		let phases;
		if (props.progress) {
			const phaseWidth = (Math.min(Sizes.progressTrackerStepWidth, (window.innerWidth - Sizes.defaultPaddingNumber * 7) / props.progress.length));
			const lineWidth = (phaseWidth - Sizes.progressTrackerCircleSize);

			phases = props.progress.map((phase, idx) => {
				const phaseSuccess = !!phase.value;
				const current = idx === props.current;

				let translationValue = phase.translateName ?
					<FormattedMessage id={ phase.value }/> : phase.value;


				return <PhaseWrapper key={ idx } width={ phaseWidth }>
					<TopPart>
						{ idx < props.progress.length - 1 &&
							<PhaseConnector fromSuccess={ phaseSuccess } toSuccess={ props.progress[idx + 1].value }
											lineWidth={ lineWidth } width={ phaseWidth }>
								<div/>
							</PhaseConnector>
						}
						<PhaseIndex success={ phaseSuccess } current={ current }>
							{ !phaseSuccess && <div>{ idx + 1 }</div> }
							{ phaseSuccess && <img src={ CheckIcon } alt="Check iCon"/> }
						</PhaseIndex>
					</TopPart>
					<PhaseText success={ phaseSuccess } current={ current }>
						{ (phase.value ? translationValue :
							<FormattedMessage id={ phase.label }/>) }
					</PhaseText>
				</PhaseWrapper>
			})
		}

		return (<Progress { ...props }>
			{ phases }
		</Progress>)

	}
}
